export default {
  VAULT_DOCUMENTS_UPLOAD_ATTEMPTED: 'Vault Document Upload Attempted',
  VAULT_DOCUMENTS_UPLOAD_COMPLETED: 'Vault Document Upload Completed',
  VAULT_DOCUMENTS_UPLOAD_FAILED: 'Vault Document Upload Failed',
};
